import { Axios } from "../Hooks/useAxiosInstance";
import { useAppContext } from "../Context/AppContext";
import { API_ROUTE } from "../Config";

export const QuizAPI = () => {
  const { user } = useAppContext();

  const apis = ({ api_token }) => ({
    create: async (data) => await createQuiz(data, api_token),
    edit: async ({ id, data }) => await updateQuiz(id, data, api_token),
    join: async (data) => await joinQuiz(data, api_token),
    start: async (id) => await startQuiz(id, api_token),
    getQuizzes: async (params) => await getQuizzes(params, api_token),
    deleteQuiz: async (id) => await deleteQuiz(id, api_token),
    inviteQuiz: async (data) => await inviteQuiz(data, api_token),
    getUserLeaderboardInfo: async (quiz_id) => await getUserLeaderboardInfo(quiz_id, api_token),
    getQuizLobbyUser: async (quiz_id) => await getQuizLobbyUser(quiz_id, api_token),
    getInvitedUser: async (quiz_id) => await getQuizInvitedUser(quiz_id, api_token),
  });



  async function createQuiz(data, api_token) {
    const url = API_ROUTE.CREATE_QUIZ;
    const option = {
      headers: {
        Authorization: api_token,
        "Content-Type": "application/json",
      },
    };
    return await Axios.post(url, data, option);
  }


  async function joinQuiz(data, api_token) {
    const url = API_ROUTE.JOIN_QUIZ;
    const option = {
      headers: {
        "Authorization": api_token,
        'Content-Type': 'application/json'
      }
    }
    return await Axios.post(url, data, option);
  }

  async function startQuiz(id, api_token) {
    const url = API_ROUTE.START_QUIZ(id);
    const option = {
      headers: {
        "Authorization": api_token,
        'Content-Type': 'application/json'
      }
    }
    return await Axios.post(url, {}, option);
  }


  async function getQuizzes(params, api_token) {
    const url = API_ROUTE.GET_QUIZ_LIST;
    const option = {
      headers: {
        Authorization: api_token,
      },
      params: params,
    };
    return await Axios.get(url, option);
  }


  async function updateQuiz(id, data, api_token) {
    const url = `${API_ROUTE.UPDATE_QUIZ_DETAILS(id)}`;
    const option = {
      headers: {
        Authorization: api_token,
        "Content-Type": "application/json",
      },
    };
    return await Axios.patch(url, data, option);
  }


  async function deleteQuiz(id, api_token) {
    const url = `${API_ROUTE.DELETE_QUIZ}/${id}`;
    const option = {
      headers: {
        Authorization: api_token,
      },
    };
    return await Axios.delete(url, option);
  }

  async function inviteQuiz(data, api_token) {
    const url = API_ROUTE.INVITE_QUIZ;
    const option = {
      headers: {
        "Authorization": api_token,
        'Content-Type': 'application/json'
      }
    }
    return await Axios.post(url, data, option);
  }

  async function getUserLeaderboardInfo(quiz_id, api_token) {
    const url = API_ROUTE.GET_USER_LEADERBOARD(quiz_id);
    const option = {
      headers: {
        Authorization: api_token,
      },
    };
    return await Axios.get(url, option);
  }

  async function getQuizLobbyUser(quiz_id, api_token) {
    const url = API_ROUTE.GET_QUIZ_LOBBY_USER(quiz_id);
    const option = {
      headers: {
        Authorization: api_token,
      },
    };
    return await Axios.get(url, option);
  }

  async function getQuizInvitedUser(quiz_id, api_token) {
    const url = API_ROUTE.GET_QUIZ_INVITED_USER(quiz_id);
    const option = {
      headers: {
        Authorization: api_token,
      },
    };
    return await Axios.get(url, option);
  }


  return apis({ api_token: user.api_token });
};